import { render } from "./SeparateSmallCourse.vue?vue&type=template&id=794048fc&scoped=true"
import script from "./SeparateSmallCourse.vue?vue&type=script&lang=js"
export * from "./SeparateSmallCourse.vue?vue&type=script&lang=js"

import "./SeparateSmallCourse.vue?vue&type=style&index=0&id=794048fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794048fc"]])

export default __exports__